import StadiumRemote from '../remote/stadiumRemote'
import { getNetworkAvailable } from '../selectors/config'
import { getUseTaxClasses } from '../selectors/menus'
import createDataDogLog from '../utils/datadog'
import { VNTAXES_FETCH_TAXES_SUCCEEDED } from './ActionTypes'
import { mapTaxes } from './Mappers'

export function fetchTaxes() {
  return async (dispatch, getState) => {
    const state = getState()

    const useTaxClasses = getUseTaxClasses(state)
    const networkConnected = getNetworkAvailable(state)

    if (!useTaxClasses || !networkConnected) {
      return
    }

    try {
      const result = await StadiumRemote.getTaxes()

      dispatch({
        type: VNTAXES_FETCH_TAXES_SUCCEEDED,
        payload: mapTaxes(result.data),
      })
    } catch (error) {
      if (error.message !== 'Network Error') {
        createDataDogLog('error', 'Error fetching taxes', error)
      }
    }
  }
}
